import React, { useEffect, useState } from "react";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp } from "../../../utils/common";
import useAuth from "../../../hooks/useAuth";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  DialogActions,
  CircularProgress,
  Stack,
  Box,
  Divider,
  useMediaQuery,
  alpha,
} from "@mui/material";
import { spacing } from "@mui/system";
import useKycDocument from "../../../hooks/useKycDocument";
import { useSearchParams } from "react-router-dom";
import UploadKycDocument from "./UploadKycDocument";
import Toolbar from "../../../components/Toolbar";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DoneIcon from "@mui/icons-material/Done";
import BrowserNotSupportedIcon from "@mui/icons-material/BrowserNotSupported";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from "@mui/icons-material/Description";

import UploadAddress from "./UploadAddress";
import UploadProfile from "./UploadProfile";
import UploadCaf from "./UploadCafForm";
import Approve from "./Approve";
import RejectKycDocument from "./RejectKycDocument";

function KycDocuments(props) {
  let [searchParams, setSearchParams] = useSearchParams();
  const { cafId } = props;
  const { t } = useTranslation();

  const { isSubmitting } = useKycDocument();

  const isMobile = useMediaQuery("(max-width:600px)"); // Adjust the max-width as needed
  const isLaptop = useMediaQuery("(min-width:601px) and (max-width:1024px)");
  const { user } = useAuth();

  console.log(user, "userrrrr");

  const userId = searchParams.get("id");

  const kycDocumentId = searchParams.get("id");

  const currentPayload = {
    filters: [
      {
        fieldName: "radUserId",
        fieldValue: kycDocumentId,
        op: "eq",
        dataType: "int",
        condition: "and",
        isJoin: true,
        attributeName: "radUser",
        entityName: "RadUserEntity",
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
  };

  const {
    getAllKycDocument,
    kycDocuments,
    kycDocument,
    paging,
    downloadFile,
    getKycDocumentImage,
  } = useKycDocument();
  const { openDialog } = useDialog();

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getAllKycDocument(payload);
  };

  const [images, setImages] = useState({});

  useEffect(() => {
    const loadImages = async () => {
      const map = {};

      for (const doc of kycDocuments) {
        if (doc.fileName != null) {
          const imgUrl = await getKycDocumentImage(doc.fileName);
          map[doc.fileName] = imgUrl;
        }
      }

      setImages(map);
    };

    loadImages();
  }, [kycDocuments]);

  useEffect(() => {
    fetchData();
  }, [payload]);

  const hasNoDocuments = !kycDocuments || kycDocuments.length === 0;

  const uploadIdClick = (title) => {
    let dropDownValues = [];
    console.log(title, "title");
    if (title == "Id Proof") {
      dropDownValues = [
        {
          key: "AADHAR_CARD",
          value: "Aadhar Card",
        },
        {
          key: "PAN_CARD",
          value: "Pan Card",
        },
        {
          key: "VOTER_ID",
          value: "Voter Id",
        },
        {
          key: "DRIVING_LIC",
          value: "Driving Licence",
        },
      ];
    }
    if (title == "Address Proof") {
      dropDownValues = [
        {
          key: "HOME_TAX",
          value: "Home Tax",
        },
        {
          key: "WATER_BILL",
          value: "Water Bill",
        },
        {
          key: "GAS_BILL",
          value: "Gas Bill",
        },
        {
          key: "GST",
          value: "GST",
        },
      ];
    }
    if (title == "Profile Proof") {
      dropDownValues = [
        {
          key: "PROFILE_PIC",
          value: "Profile Pic",
        },
      ];
    }
    if (title == "CAF Proof") {
      dropDownValues = [
        {
          key: "CAF_PROOF",
          value: "Caf Proof",
        },
      ];
    }
    return openDialog(
      "upload_id_proof",
      "Upload Id Proof",
      <UploadKycDocument
        key={getTimeStamp()}
        radUserId={searchParams.get("id")}
        dropDownValues={dropDownValues}
        documentTitle={title}
        refreshPage={fetchData}
      />,
    );
  };

  const approveClick = (kycDocumentId) => {
    return openDialog(
      "approve",
      "Approve",
      <Approve key={getTimeStamp()} kycDocumentId={kycDocumentId} refreshPage={fetchData} />,
    );
  };

  const rejectClick = (kycDocumentId) => {
    return openDialog(
      "reject",
      "Reject KYC",
      <RejectKycDocument
        key={getTimeStamp()}
        kycDocumentId={kycDocumentId}
        refreshPage={fetchData}
      />,
    );
  };

  const uploadProfileClick = (id) => {
    return openDialog(
      "Upload Profile Proof",
      <UploadProfile key={getTimeStamp()} userId={searchParams.get("id")} />,
    );
  };

  const uploadCafClick = (id) => {
    return openDialog(
      "Upload Caf Proof",
      true,
      <UploadCaf key={getTimeStamp()} userId={searchParams.get("id")} />,
    );
  };

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const approveOrRejectPermission = () => {
    if (!user) return false;

    const allowedTypes = ["SUPER_ADMIN", "MULTI_SERVICE_OPERATOR"];

    return allowedTypes.includes(user.businessType);
  };

  const downloadKycDocument = (url, title) => {
    console.log(url, "url9090");
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", title); // download filename
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const columns = [
    {
      field: "documentName",
      headerName: "Document Name",
      flex: 1,
    },
  ];

  const standardDocs = ["Id Proof", "Address Proof", "Profile Proof", "CAF Proof"];

  // Create a list that always contains the standard docs in order
  const displayDocs = standardDocs.map((title) => {
    const existing = kycDocuments.find((d) => d.title === title);
    if (existing) return existing;
    return {
      title,
      fileName: null,
      kycStatus: null,
      userKycDocumentId: null,
    };
  });

  // Add any additional documents that are not part of the standard set
  kycDocuments.forEach((doc) => {
    if (!standardDocs.includes(doc.title)) {
      displayDocs.push(doc);
    }
  });

  const isPending = (status) => status && status.trim().toLowerCase() === "pending";

  return (
    <Card mb={6}>
      <CardHeader
        action={
          <Toolbar
            isEnableImport={true}
            openDownloadDialog={() => uploadIdClick("Id Proof")}
            refreshPage={fetchData}
          />
        }
        title={t("kyc_documents")}
      />
      <CardContent>
        <Grid container spacing={6} id="invoice_details">
          {displayDocs.map((kycDocument) => (
            <Grid item xs={12} md={6}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 3,
                  padding: 2,
                  marginBottom: 1,
                  background: kycDocument.fileName ? "inherit" : alpha("#f4f6f8", 0.5),
                  border: kycDocument.fileName ? "none" : "1px dashed #ccc",
                }}
              >
                <CardHeader
                  title={kycDocument.title}
                  titleTypographyProps={{ fontSize: 18, fontWeight: 600 }}
                  sx={{ pb: 0 }}
                />
                <CardContent sx={{ textAlign: "center" }}>
                  {/* Document Image Placeholder */}
                  <Box
                    sx={{
                      border: "1px solid #ddd",
                      borderRadius: 2,
                      overflow: "hidden",
                      width: "100%",
                      maxWidth: 380,
                      margin: "auto",
                      height: 220,
                      background: "#fafafa",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    {kycDocument.title === "CAF Proof" && cafId != null ? (
                      <Link
                        to={"/caf/details?id=" + cafId}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                      >
                        <Button variant="contained">View CAF Details</Button>
                      </Link>
                    ) : kycDocument.fileName ? (
                      <img
                        src={images[kycDocument.fileName]}
                        alt={kycDocument.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <Box sx={{ color: "text.disabled", textAlign: "center" }}>
                        <DescriptionIcon sx={{ fontSize: 60, mb: 1, opacity: 0.3 }} />
                        <Typography variant="body2" color="textSecondary">
                          {t("No document uploaded")}
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* Buttons */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                      mt: 3,
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {/* Upload */}
                    <Button
                      variant={kycDocument.fileName ? "outlined" : "contained"}
                      color="primary"
                      startIcon={<UploadFileIcon />}
                      onClick={() => uploadIdClick(kycDocument.title)}
                      size={isMobile ? "small" : "medium"}
                    >
                      {kycDocument.fileName ? t("Re-upload") : t("Upload")}
                    </Button>

                    {/* Approve / Reject (only for admins/MSO) */}
                    {approveOrRejectPermission() && isPending(kycDocument.kycStatus) && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={<DoneIcon />}
                          onClick={() => approveClick(kycDocument.userKycDocumentId)}
                          size={isMobile ? "small" : "medium"}
                        >
                          Approve
                        </Button>

                        <Button
                          variant="contained"
                          color="error"
                          startIcon={<BrowserNotSupportedIcon />}
                          onClick={() => rejectClick(kycDocument.userKycDocumentId)}
                          size={isMobile ? "small" : "medium"}
                        >
                          Reject
                        </Button>
                      </>
                    )}

                    {/* Status */}
                    {kycDocument.kycStatus === "Approved" && (
                      <Button variant="contained" color="success" disabled>
                        Approved
                      </Button>
                    )}

                    {kycDocument.kycStatus === "Rejected" && (
                      <Button variant="contained" color="error" disabled>
                        Rejected
                      </Button>
                    )}

                    {/* Download (only after approval) */}
                    {kycDocument.kycStatus === "Approved" && (
                      <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<DownloadIcon />}
                        onClick={() =>
                          downloadKycDocument(images[kycDocument.fileName], kycDocument.title)
                        }
                        size={isMobile ? "small" : "medium"}
                      >
                        Download
                      </Button>
                    )}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default KycDocuments;
